import {Table,Modal,ModalOverlay,ModalContent,ModalCloseButton,ModalBody,ModalFooter,ModalHeader,
    Thead,Stack,Select,useToast,Tbody,Tr,Th,Td,TableContainer, Button, IconButton,Tooltip,Menu, 
    MenuButton,MenuList,MenuItem,Divider,Input} from '@chakra-ui/react';
import {MdCancel,MdOutlinePictureAsPdf} from 'react-icons/md';
import {WarningTwoIcon,WarningIcon,EditIcon,CheckIcon,  HamburgerIcon,DeleteIcon} from '@chakra-ui/icons';

import { useState,useEffect } from 'react';
import PdfViewer from '../custom/PdfViewer';
import MaleFemale from '../custom/MaleFemale';
import '../../css/rgg.css';

const GovScanResult=({data=[],size='xs',onClose,onDelete,onUpdateItem,pasmine=[],errmsg="",drzavamodelskeniranja="HR",readonly=false})=>{

    const [pdfid,setPdfId]=useState(0);
    const [edititem,setEditItem]=useState({id:-1,zivbr_adjusted:"",zivbr_adjusted_isvalid:false,mzivbr_adjusted:"",mzivbr_adjusted_isvalid:false,spol_adjusted:"",pasmina_adjusted:"",pasminasif_adjusted:"",putnica_serbr_adjusted:"",datrod_adjusted:new Date('1900-1-1')});
    const toast=useToast();
    const onClosePdf=()=>{
        setPdfId(0);
    }

    useEffect(()=>{
        const showErrMessage=()=>{
            if (errmsg!=="") {
                toast({
                    title:"Greška kod dohvata podataka.",
                    status:"error",
                    description:errmsg,
                    isClosable:true,
                    duration:2000,
                    position:"top-right",
                });
            }
        }
        showErrMessage();
    },[errmsg])

    const showPdf=()=>{
        if (pdfid!==0) {
            return (
                <Modal isOpen={true} onClose={onClosePdf} size={'6xl'}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader bg={'gray.100'}>Putni list</ModalHeader>
                        <ModalCloseButton onClick={onClosePdf} />
                        <ModalBody>
                            <PdfViewer id={pdfid}/>
                        </ModalBody>

                        <ModalFooter>
                            <Button rightIcon={<MdCancel/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={onClosePdf}>Zatvori</Button>  
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            )
        }
    }
    

    const isValid=(item)=>{
        let _r=true;
        if (!(item.zivbr_isvalid && item.mzivbr_isvalid && item.spol_isvalid && item.pasmina_isvalid && item.datrod_isvalid )) {
            _r=false;
        }
        if (item.scanerrmsg!=="") {
            _r=false;
        }
        return _r;
    }

    const getIcon=(item)=>{
        let _r=isValid(item);
        let _txt="Podaci su ispravni.";
        

        let _icon=<CheckIcon color={edititem.id>0?"grunt2.300":"green.500"}/>;
        let _ispravno=true;

        if (item.drzava!==drzavamodelskeniranja) {
            _txt="Država putnice goveda ne odgovara državi putnice ostalih goveda.";
            _icon=<WarningTwoIcon color={edititem.id>0?"grunt2.300":"red.500"}/>;
            _ispravno=false;
        }

        if (_ispravno && item.govedo_evidentirano) {
            _txt="Grlo je već prije evidentirano u migracijama.";
            _icon=<WarningTwoIcon color={edititem.id>0?"grunt2.300":"red.500"}/>;
            _ispravno=false;
        }

        if (_ispravno && !_r) {
            _txt="Greška u podacima";
            _icon=<WarningIcon color={edititem.id>0?"grunt2.300":"red.500"}/>;
        }

        if (item.scanerrmsg!=="") {
            _txt="Greška u podacima. Greška: " + item.scanerrmsg;
            _icon=<WarningIcon color={edititem.id>0?"grunt2.300":"red.500"}/>;
        }

        

        
        return (<Tooltip label={_txt}>{_icon}</Tooltip>)



    }

    const showPasmineList=()=>{
        return (
            <Select focusBorderColor='grunt2.400' id="slct_pasmina" onChange={onItemValueChange} size={size} variant={'filled'} defaultValue={edititem.pasminasif_adjusted===""?"03":edititem.pasminasif_adjusted} 
            textAlign={'center'} borderColor={'grunt2.400'} w={'100%'}>
                                {
                                pasmine.map((item,i)=>{
                                    return (
                                        <option key={`psm${i}`} value={item.sifra}>{item.naziv}</option>        
                                    )
                                })
                                }
                                
                            </Select>
        )
    }

 const getMenuList=(item)=>{
    const _canbedeleted=data.length>1;
    
        return (
            <MenuList>
                    <MenuItem size={size} isDisabled={readonly} icon={<EditIcon boxSize={'14px'}/>} onClick={()=>{setItemForEdit(item)}}>Uredi</MenuItem>
                    <MenuItem size={size} icon={<MdOutlinePictureAsPdf size={'14px'}/>} onClick={()=>{setPdfId(item.id)}}>Pregled dokumenta</MenuItem>
                    <Divider/>
                    <MenuItem color={'red.600'} size={size} isDisabled={readonly || !_canbedeleted} icon={<DeleteIcon boxSize={'14px'}/>} onClick={()=>{deleteItem(item.id)}}>Briši</MenuItem>
            </MenuList>
        )
    
 }    

    const showDataTabular=()=>{
        return (
            <TableContainer overflowY={'auto'} h={'85vh'} mb={'0.5rem'} pr={'0.5rem'} textAlign={'center'} className='noscroll' >
                <Table size={'xs'} variant={'unstyled'} color={'grunt2.800'} fontSize={'xs'} layout='fixed'>
                    <Thead borderBottomColor={'grunt2.400'} borderBottomWidth={'1px'} borderBottomStyle={'solid'} borderTopColor={'grunt2.400'} borderTopWidth={'1px'} borderTopStyle={'solid'}>
                        <Tr>
                            <Th w={'2%'}></Th>
                            <Th w={'2%'}></Th>
                            <Th w={'2%'}>Rbr</Th>
                            <Th w={'3%'} textAlign={'center'}>Str.</Th>
                            <Th w={'18%'} colSpan={2} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>Životni broj</Th>
                            <Th w={'18%'} colSpan={2} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>Životni broj majke</Th>
                            <Th w={'10%'} colSpan={2} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>Spol</Th>
                            <Th w={'22%'}colSpan={2} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>Pasmina</Th>
                            <Th w={'12%'}colSpan={2} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>Rođenje</Th>
                            <Th w={'12%'}colSpan={2} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>Br. putnice</Th>
                        </Tr>
                    </Thead>
                    <Tbody borderBottomColor={'grunt2.400'} borderBottomWidth={'1px'} borderBottomStyle={'solid'}>
                        {data.map((item,index)=>{
                            if (item.id===edititem.id) {
                                return (
                                    <Tr h='2rem' bg={'grunt2.100'} key={`row${index}`}>
                                        <Td colSpan={2} textAlign={'center'}>
                                        <Stack direction={'row'} display={'block'}>
                                                <IconButton bg={'grunt2.100'} mr={'0.3rem'} color={'green.700'} size={size} aria-label='Search database' icon={<CheckIcon/>} onClick={applyChanges}/>
                                                <IconButton bg={'grunt2.100'} size={size} color={'red.700'} aria-label='Search database' icon={<MdCancel/>} onClick={cancelItemForEdit}/>
                                            </Stack>
                                        </Td>
                                        
                                        <Td>{index+1}</Td>
                                        <Td textAlign={'center'} color={item.drzava===drzavamodelskeniranja?'black':'red'}>{item.strana}</Td>
                                        <Td overflowX={'clip'} color={item.zivbr_isvalid?'black':'red'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>{item.zivbr}</Td>
                                        <Td textAlign={'center'}>
                                            <Input focusBorderColor='grunt2.400' errorBorderColor={'red.400'} isInvalid={!edititem.zivbr_adjusted_isvalid} onChange={onItemValueChange} id='inp_zivbr' maxLength={20} variant={'filled'} borderColor={'grunt2.400'} textAlign={'center'} size={size} w={'100%'} key={`inzb${item.id}`} value={edititem.zivbr_adjusted}></Input>
                                        </Td>
                                        <Td overflowX={'clip'} color={item.mzivbr_isvalid?'black':'red'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>{item.mzivbr}</Td>
                                        <Td textAlign={'center'}>
                                            <Input focusBorderColor='grunt2.400' errorBorderColor={'red.400'} isInvalid={!edititem.mzivbr_adjusted_isvalid} onChange={onItemValueChange} id='inp_mzivbr' maxLength={20} variant={'filled'} borderColor={'grunt2.400'} textAlign={'center'} size={size} w={'100%'} key={`inzb${item.id}`} value={edititem.mzivbr_adjusted}></Input>
                                        </Td>
                                        <Td overflowX={'clip'} color={item.spol_isvalid?'black':'red'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>{item.spol}</Td>
                                        <Td textAlign={'center'}>
                                            {/* {item.spol_adjusted==="f"?"Ž":item.spol_adjusted==="m"?"M":""} */}
                                            <MaleFemale value={edititem.spol_adjusted} onChange={handleSpolChange}/>
                                        </Td>
                                        <Td overflowX={'clip'} color={item.pasmina_isvalid?'black':'red'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>
                                            {item.pasmina}
                                        </Td>
                                        <Td textAlign={'center'}>
                                            {showPasmineList()}
                                        </Td>
                                        <Td overflowX={'clip'} color={item.datrod_isvalid?'black':'red'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>{item.datrod}</Td>
                                        <Td textAlign={'center'}>
                                            <Input focusBorderColor='grunt2.400' w={'100%'} errorBorderColor={'red.400'} isInvalid={edititem.datrod_adjusted==='1900-01-01'} id='inp_datrod'  variant={'filled'} borderColor={'grunt2.400'} size={size} type="date" onChange={onItemValueChange} value={new Date(edititem.datrod_adjusted).toISOString().split("T")[0]}/> 
                                        </Td>
                                        <Td overflowX={'clip'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>{item.putnica_serbr}</Td>
                                        <Td textAlign={'center'}>
                                            <Input focusBorderColor='grunt2.400' errorBorderColor={'red.400'} onChange={onItemValueChange} id='inp_putserbr' maxLength={8} variant={'filled'} borderColor={'grunt2.400'} textAlign={'center'} size={size} w={'100%'} key={`putsrbr${item.id}`} value={edititem.putnica_serbr_adjusted}></Input>
                                        </Td>
                                    </Tr>
                                )
                            } else {
                                return (
                                    <Tr _hover={{bg:'gray.100'}} h='2rem' borderColor={'red'}>
                                        <Td textAlign={'center'}>
                                            <Menu size={size}>
                                                <MenuButton isDisabled={edititem.id!==-1} as={IconButton} aria-label='Options' icon={<HamburgerIcon />} variant={'outline'} size={size}/>
                                                    {getMenuList(item)}
                                                </Menu>
                                        </Td>
                                        <Td>{getIcon(item)}</Td>
                                        <Td>{index+1}</Td>
                                        <Td textAlign={'center'} color={item.drzava===drzavamodelskeniranja?'black':'red'}>{item.strana}</Td>
                                        <Td overflowX={'clip'} color={item.zivbr_isvalid?'black':'red'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>{item.zivbr}</Td>
                                        <Td textAlign={'center'}>{item.zivbr_adjusted}</Td>
                                        <Td overflowX={'clip'} color={item.mzivbr_isvalid?'black':'red'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>{item.mzivbr}</Td>
                                        <Td textAlign={'center'}>{item.mzivbr_adjusted}</Td>
                                        <Td overflowX={'clip'} color={item.spol_isvalid?'black':'red'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>{item.spol}</Td>
                                        <Td textAlign={'center'}>{item.spol_adjusted==="f"?"Ž":item.spol_adjusted==="m"?"M":""}</Td>
                                        <Td overflowX={'clip'}  color={item.pasmina_isvalid?'black':'red'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>{item.pasmina}</Td>
                                        <Td textAlign={'center'} fontSize={item.pasmina_adjusted.length>15?'x-small':'inherit'}>{item.pasmina_adjusted}</Td>
                                        <Td overflowX={'clip'} color={item.datrod_isvalid?'black':'red'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>{item.datrod}</Td>
                                        <Td textAlign={'center'}>{new Date(item.datrod_adjusted).getFullYear()===1900?null:new Date(item.datrod_adjusted).toLocaleDateString('hr-HR')}</Td>
                                        <Td overflowX={'clip'} textAlign={'center'} borderLeftColor={'grunt2.200'} borderLeftWidth={'1px'} borderLeftStyle={'solid'}>{item.putnica_serbr}</Td>
                                        <Td textAlign={'center'}>{item.putnica_serbr_adjusted}</Td>
                                    </Tr>
                                )
                            }
                            
                        })}
                    </Tbody>
                </Table>
            </TableContainer>
        )
    }

    const applyChanges=()=>{
        if (edititem.zivbr_adjusted_isvalid && edititem.mzivbr_adjusted_isvalid && edititem.datrod_adjusted!=='1900-01-01') {
            onUpdateItem(edititem.id,edititem.zivbr_adjusted,edititem.mzivbr_adjusted,edititem.spol_adjusted,edititem.pasminasif_adjusted,edititem.datrod_adjusted,edititem.pasmina_adjusted,edititem.putnica_serbr_adjusted);
            cancelItemForEdit();
        }
        
    }

    const handleSpolChange=(spol)=>{
        setEditItem({...edititem,spol_adjusted:spol});
    }

    const onItemValueChange=(event)=>{
        const x=event.target.id;
        const val=event.target.value.toUpperCase();
        let b=false;
        //TESTIRANJE JEL ZIVBR U FORMATU XXNNNNNNNN gdje je XX slovo A N broj
        const rg_zivbr=/^[A-Z]{2}\s[0-9]{3,17}$/g;
        
        if (x==="inp_zivbr") {
            b=rg_zivbr.test(val);
            setEditItem({...edititem,zivbr_adjusted:val,zivbr_adjusted_isvalid:b});
        }
        if (x==="inp_mzivbr") {
            b=rg_zivbr.test(val);
            setEditItem({...edititem,mzivbr_adjusted:val,mzivbr_adjusted_isvalid:b});
        }
        if (x==="inp_datrod") {
            if (val!=="") {
                setEditItem({...edititem,datrod_adjusted:val});    
            }
            
        }
        if (x==="inp_putserbr") {
            setEditItem({...edititem,putnica_serbr_adjusted:val});
        }
        if (x==="slct_pasmina") {
            setEditItem({...edititem,pasminasif_adjusted:val,pasmina_adjusted:event.target.options[event.target.selectedIndex].text});
        }
    }

    const setItemForEdit=(scanitem)=>{
        setEditItem({...edititem,id:scanitem.id,zivbr_adjusted:scanitem.zivbr_adjusted,zivbr_adjusted_isvalid:scanitem.zivbr_isvalid,putnica_serbr_adjusted:scanitem.putnica_serbr_adjusted,mzivbr_adjusted:scanitem.mzivbr_adjusted,mzivbr_adjusted_isvalid:scanitem.mzivbr_isvalid,spol_adjusted:scanitem.spol_adjusted===""?"m":scanitem.spol_adjusted,pasmina_adjusted:scanitem.pasmina_adjusted.trim()===""?"OSTALI KRIŽANCI":scanitem.pasmina_adjusted,pasminasif_adjusted:scanitem.pasminasifra_adjusted===""?"03":scanitem.pasminasifra_adjusted,datrod_adjusted:scanitem.datrod_adjusted});
    }
    const cancelItemForEdit=()=>{
        setEditItem({...edititem,id:-1,zivbr_adjusted:"",zivbr_adjusted_isvalid:false,mzivbr_adjusted:"",mzivbr_adjusted_isvalid:false,spol_adjusted:"",putnica_serbr_adjusted:"",pasminasif_adjusted:"",datrod_adjusted:new Date('1900-01-01')});
    }

    const deleteItem=(id)=>{
        onDelete(id);
    }
    return (
        <>
             {showDataTabular()} 
            {/* {showDataGrouped()} */}
            <Button rightIcon={<MdCancel/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={onClose}>Zatvori</Button>
            {showPdf()}
           
        </>
    )
}

export default GovScanResult;